import { addFoodifoxLog } from './axios/FoodifoxDataAPI';

/**
 * 添加系统日志
 * @param cabId
 * @param deviceCode
 * @param platform
 * @param logDesc
 * @param sessionId
 */
function addSystemLog(cabId: number, deviceCode: string, platform: string, logDesc: string, sessionId?: string) {
  addFoodifoxLog('fox3PDAiLog/addLog', {
    cabId,
    deviceCode,
    platform,
    logDesc,
    sessionId,
  });
}

export {
  addSystemLog,
};
